module.exports = __webpack_public_path__ + "static/media/Midjourney_ai.185d6bd1.png";